import { createZodDto } from "nestjs-zod/dto";
import { z } from "zod";

import { userSchema } from "../user";

export const registerSchema = userSchema
  .pick({ name: true, email: true, username: true, locale: true })
  .extend({
    // Custom message — Zod's default ("String must contain at least 6
    // character(s)") leaked through to the UI and confused users.
    password: z.string().min(6, { message: "Password must be at least 6 characters." }),
    // Referral: passed from the ?ref=<userId> cookie captured on first visit.
    // Kept optional so regular signups are unaffected; self-referrals are
    // blocked server-side.
    referrerId: z.string().optional(),
  });

export class RegisterDto extends createZodDto(registerSchema) {}
